module.exports = __webpack_public_path__ + "static/media/aman_kumar.1908b735.jpg";